import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "hr_cookie_consent";

export function CookieConsent() {
  const { pathname } = useLocation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setShow(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  // Don't show inside the admin portal, reset-password, or onboarding (overlaps the sticky CTA).
  if (pathname.startsWith("/admin") || pathname.startsWith("/reset-password") || pathname.startsWith("/onboarding")) return null;
  if (!show) return null;

  const choose = (value) => { localStorage.setItem(KEY, value); setShow(false); };

  return (
    <div className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-6 sm:bottom-6 sm:max-w-md z-[60] bg-forest text-bone shadow-2xl border border-bone/10" data-testid="cookie-consent">
      <div className="p-5">
        <div className="flex items-start gap-3">
          <span className="w-9 h-9 shrink-0 grid place-items-center bg-blaze text-white"><Cookie size={18} /></span>
          <div>
            <p className="font-serif text-lg leading-tight">We use cookies</p>
            <p className="text-bone/70 text-sm mt-1">
              HomeRange uses cookies to keep you signed in, remember preferences, and understand how the Platform is used. See our{" "}
              <Link to="/privacy" className="text-blaze hover:underline" data-testid="cookie-privacy-link">Privacy Policy</Link>.
            </p>
          </div>
        </div>
        <div className="flex gap-2 mt-4 justify-end">
          <button onClick={() => choose("declined")} className="px-4 py-2 text-sm font-semibold border border-bone/30 text-bone/80 hover:bg-bone/10 transition-colors" data-testid="cookie-decline">Decline</button>
          <button onClick={() => choose("accepted")} className="px-4 py-2 text-sm font-semibold bg-blaze text-white hover:bg-blaze-dark transition-colors" data-testid="cookie-accept">Accept</button>
        </div>
      </div>
    </div>
  );
}
